module.exports = __webpack_public_path__ + "static/media/click-02.6adb2e76.mp3";